/* 🤖 this file was generated by svg-to-ts */
export const DfIconArrowBackward16: {
  name: 'arrow-backward-16';
  data: string;
} = {
  name: 'arrow-backward-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M8 5.125c.07.441.494.875 1 .875 3.005.76 5.335 2.39 6.86 4.626a.777.777 0 0 1-.03.931c-.31.4-.926.657-1.4.19-1.975-2.099-6.199-2.343-6.43-.876v1.13a1 1 0 0 1-1.556.831l-5.999-4a1 1 0 0 1 0-1.664l6-4A1 1 0 0 1 8 4z"/></svg>`
};
